import React from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { RecaptchaProps } from '../types/recatptcha-props';

type Props = Pick<RecaptchaProps, 'error'> & {
  children: any;
};

const Container = styled.div<{
  hasError?: boolean;
}>`
  width: fit-content;
  margin: -7px -7px -1px;
  padding: 7px;
  outline: 1px solid transparent;
  outline-color: ${(props) => props.hasError && 'var(--olymp-robot-error, #f15132)'};
`;

const RecaptchaRoot = React.forwardRef<HTMLDivElement, Props>(({ children, error }, ref) => {
  return (
    <Container ref={ref} hasError={error}>
      {children}
    </Container>
  );
});

export default React.memo(RecaptchaRoot);
